import React, { useEffect } from 'react';
import { $generateHtmlFromNodes } from '@lexical/html';
import { $getRoot } from 'lexical';
import { PlainlyFormat } from '../types';
import { useEditor } from '../editor';

interface PlainlyOutputPluginProps {
  onChange: (value: PlainlyFormat) => void;
}

const FONT_SIZE = 150;
const VERTICAL_PADDING = 60;

export const PlainlyOutputPlugin: React.FC<PlainlyOutputPluginProps> = ({ onChange }) => {
  const { editor } = useEditor();

  useEffect(() => {
    if (!editor) return;

    const unregister = editor.registerUpdateListener(() => {
      editor.getEditorState().read(() => {
        // 1. Generar HTML
        const htmlString = $generateHtmlFromNodes(editor);

        // 2. Extraer texto plano del DOM
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const plainText = (doc.body.textContent || '')
          .trim()
          .replace(/\s+/g, ' ')
          .replace(/\n\s+/g, '\n')
          .replace(/\s+\n/g, '\n');

        // 3. Contar líneas (párrafos)
        const root = $getRoot();
        const numberOfLines = root.getChildren().length;

        // 4. Calcular altura
        // Cada línea ocupa FONT_SIZE, y le sumamos VERTICAL_PADDING extra para evitar cortes de texto arriba/abajo
        const canvasHeight = numberOfLines * FONT_SIZE + VERTICAL_PADDING;

        // 5. Emitir PlainlyFormat completo
        onChange({
          text: plainText,
          html: htmlString,
          numberOfLines,
          canvasHeight
        });
      });
    });

    return unregister;
  }, [editor, onChange]);

  return null;
};
